import { render, staticRenderFns } from "./passwordReset.vue?vue&type=template&id=40b11d75&"
import script from "./passwordReset.vue?vue&type=script&lang=js&"
export * from "./passwordReset.vue?vue&type=script&lang=js&"
import style0 from "./passwordReset.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports